import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import { FurnitureTypes, LightsTypes, TVTypes } from './current-model-state';

type GroupState = {
    title: string;
    slug: 'tvFirst' | 'tvSecond' | 'lightsFirst' | 'lightsSecond' | 'furnitureFirst' | 'furnitureSecond';
    property: {
        label: string;
        slug: LightsTypes | TVTypes | FurnitureTypes;
        hint?: string;
    }[];
};

const currentGroupPickerState = atom<{
    title: string;
    values: GroupState[];
}>({
    key: 'currentGroupPickerState',
    default: {
        title: '',
        values: [],
    },
});

export const useCurrentGroupPickerStateValue = () => useRecoilValue(currentGroupPickerState);

export const useSetCurrentGroupPickerState = () => useSetRecoilState(currentGroupPickerState);
